import React from 'react';
import { Link } from 'react-router-dom';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import {
  hasPermission,
  totalActivePermisssions,
  PERMISSION_NAME,
} from 'v2/utils/permissions';
import { RootState } from 'v2/models';
import classnames from 'classnames';
import styles from './navbar.module.scss';
import { useSelector } from 'react-redux';
import { OverlayInjectedProps } from 'react-bootstrap/esm/Overlay';

const buttonUpgradeTooltip = (props: OverlayInjectedProps) => (
  <Tooltip id="upgrade-tooltip" {...props}>
    <div>Your account is being reviewed. Check back soon to upgrade!</div>
  </Tooltip>
);

const UpgradeButton = () => {
  const user = useSelector((state: RootState) => state.user.user);
  const permissions = useSelector(
    (state: RootState) => state.permissions.permissions
  );

  const hasDrmPermission = hasPermission(permissions, [PERMISSION_NAME.DRM]);
  const totalPermissions = totalActivePermisssions(permissions);
  if (totalPermissions !== 1 || !hasDrmPermission) {
    return null;
  }

  return (
    <OverlayTrigger
      placement="bottom"
      overlay={(props) => buttonUpgradeTooltip(props)}
      show={user.waitlisted ? undefined : false}
    >
      <span className={styles.showTooltip}>
        <Link
          data-testid="UpgradeButton"
          to={'/settings/subscription'}
          className={classnames(
            'btn btn-primary',
            styles.upgradeButton,
            styles.hideMobile,
            { [styles.disabled]: user.waitlisted }
          )}
        >
          Upgrade
        </Link>
      </span>
    </OverlayTrigger>
  );
};

export default UpgradeButton;
